// extracted by mini-css-extract-plugin
export var content = "_dt-3";
export var list = "_dt-4";
export var settingsContent = "_dt-7";
export var settingsPanel = "_dt-8";
export var state = "_dt-6";
export var triggerBadge = "_dt-2";
export var triggerButton = "_dt-1";
export var triggerShell = "_dt-0";
export var unreadDot = "_dt-5";